import { render, staticRenderFns } from "./mat_request.vue?vue&type=template&id=285f6a24&scoped=true&"
import script from "./mat_request.vue?vue&type=script&lang=js&"
export * from "./mat_request.vue?vue&type=script&lang=js&"
import style0 from "./mat_request.vue?vue&type=style&index=0&id=285f6a24&lang=less&scoped=true&"
import style1 from "./mat_request.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285f6a24",
  null
  
)

export default component.exports